<template>
  <a-form-item name="privacy" value-prop-name="checked" :rules="formPrivacyConsentRules">
    <a-checkbox
      class="form-privacy-consent-field"
      :checked="modelValue"
      @update:checked="emit('update:modelValue', $event)"
    >
      <span :style="{ color: '#1A01BA' }">Согласен </span>
      <span>и принимаю </span>
      <a :href="policyUrl" target="_blank" rel="noopener noreferrer">политику конфиденциальности</a>
    </a-checkbox>
  </a-form-item>
</template>

<script lang="ts" setup>
import type { Rule } from 'ant-design-vue/es/form';

withDefaults(
  defineProps<{
    modelValue: boolean;
    policyUrl?: string;
  }>(),
  {
    policyUrl: 'https://vgbitrix.osinit.com/politika.php',
  },
);

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
}>();

const formPrivacyConsentRules: Rule[] = [{ required: true, message: '', type: 'boolean' }];
</script>

<style>
.form-privacy-consent-field.ant-checkbox-wrapper {
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings:
    'dlig' on,
    'liga' off;
  font-family: Involve;
  font-size: 12px;
  font-weight: 500;
  line-height: 153%;
}

.form-privacy-consent-field a {
  color: var(--stc-brand-600);
  text-decoration: none;
}

.form-privacy-consent-field a:hover {
  color: var(--stc-brand-600);
  text-decoration: underline;
}

.form-privacy-consent-field.ant-checkbox-wrapper:hover
  .ant-checkbox:not(.ant-checkbox-disabled)
  .ant-checkbox-inner,
.form-privacy-consent-field .ant-checkbox:hover > .ant-checkbox-inner {
  border-color: var(--stc-brand-600) !important;
}

.form-privacy-consent-field.ant-checkbox-wrapper:hover
  .ant-checkbox-checked:not(.ant-checkbox-disabled)
  .ant-checkbox-inner,
.form-privacy-consent-field
  .ant-checkbox-checked:not(.ant-checkbox-disabled):hover
  .ant-checkbox-inner {
  background-color: var(--stc-brand-600) !important;
  border-color: var(--stc-brand-600) !important;
}

.form-privacy-consent-field .ant-checkbox.ant-checkbox-checked:not(.ant-checkbox-disabled)::after {
  border-color: var(--stc-brand-600) !important;
}

.form-privacy-consent-field.ant-checkbox-wrapper:hover
  .ant-checkbox.ant-checkbox-checked:not(.ant-checkbox-disabled)::after,
.form-privacy-consent-field
  .ant-checkbox.ant-checkbox-checked:not(.ant-checkbox-disabled):hover::after {
  border-color: var(--stc-brand-600) !important;
}

.form-privacy-consent-field .ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--stc-brand-600) !important;
  border-color: var(--stc-brand-600) !important;
}

.form-privacy-consent-field .ant-checkbox-checked:hover .ant-checkbox-inner,
.form-privacy-consent-field.ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--stc-brand-600) !important;
  border-color: var(--stc-brand-600) !important;
}
</style>
